<template>
    <start-menu class="pt-lg-3" :flat="true">
        <side-menu-link to="/terms" :ignoreGroup="true" class="side-menu-icon-link">
            <span class="link-label">Terms &amp; Conditions</span>
        </side-menu-link>
        <side-menu-link to="/terms/booking-agreement" class="side-menu-icon-link">
            <span class="link-label">Booking Agreement</span>
        </side-menu-link>
        <side-menu-link to="/terms/promotion-agreement" class="side-menu-icon-link">
            <span class="link-label">Promotion Agreement</span>
        </side-menu-link>
        <side-menu-link to="/terms/marquis-mandates" class="side-menu-icon-link">
            <span class="link-label">The Marquis Mandates</span>
        </side-menu-link>
        <side-menu-link to="/terms/service-agreement" class="side-menu-icon-link">
            <span class="link-label">Master Services Agreement</span>
        </side-menu-link>
        <side-menu-link to="/terms/dispute-resolution-center" class="side-menu-icon-link">
            <span class="link-label">Dispute Resolution Center</span>
        </side-menu-link>
        
        <side-menu-link to="/terms/insurance-information" class="side-menu-icon-link">
            <span class="link-label">Insurance Information</span>
        </side-menu-link>
        <side-menu-link to="/terms/privacy-policy" class="side-menu-icon-link">
            <span class="link-label">Privacy Policy</span>
        </side-menu-link>
        <side-menu-link to="/terms/concierge" class="side-menu-icon-link">
            <span class="link-label">Concierge Agreement</span>
        </side-menu-link>
        <side-menu-link to="/terms/cancellation-policy" class="side-menu-icon-link">
            <span class="link-label">Cancellation Policy</span>
        </side-menu-link>
        <side-menu-link to="/terms/service-fee" class="side-menu-icon-link">
            <span class="link-label">Service Fee</span>
        </side-menu-link>
        
    </start-menu>
</template>
<script type="text/javascript">
    import StartMenu from '@/components/Layout/StartMenu.vue';
    import SideMenuLink from '@/components/Layout/SideMenuLink.vue';

    export default {

        components: {
            StartMenu, SideMenuLink,
        },

    };

</script>